import axios from '../index';

// 账户注册
export const registerVerifyCode = (data) => {
  return axios.post('/api/register/verifyEmailCode', data);
};

// 账户注册
export const registerSubmit = (data) => {
  return axios.post('/api/register/userAndLogin', data);
};

// 短信码发送（注册）
export const registerSendCode = (email) => {
  return axios.get('/api/register/sendEmailCode/' + email);
};

// 短信码发送（注册）V2 带邀请码
export const registerSendCodeV2 = (data) => {
  return axios.post('/api/register/sendEmailCodeV2', data);
};

// 检查是否需要验证码
export const fetchCheckRequired = () => {
  return axios.get('/api/invitation/checkRequired');
};
